const printers = [
    {
        name: 'Ender3 V2 Neo',
        port: 'COM4',
        baudRate: 115200,
    },
    {
        name: 'Ender3 V3 SE',
        port: '/dev/ttyUSB0',
        baudRate: 250000,
    },
    {
        name: 'Ender 5',
        port: '/dev/ttyUSB1',
        baudRate: 115200,
    },
];

export default printers;
